import { CountryCode } from 'libphonenumber-js'
import * as yup from 'yup'

const REGEX_PHONE = /^04[0-9]{8}$/

export const phoneNumberValidation = (value: string, countryCode: string) => {
  return yup
    .string()
    .trim()
    .required(`${value} is required`)
    .test(
      'validationMobileNumber',
      'Please enter a valid mobile number.',
      async (value) => {
        const { isValidPhoneNumber } = await import('libphonenumber-js')
        return isValidPhoneNumber(value, countryCode as CountryCode)
      }
    )
}

export const phoneNumberOptionalValidation = () => {
  return yup.string().optional().trim().matches(REGEX_PHONE, {
    excludeEmptyString: true,
    message: `Please enter a valid Australian mobile number. It must be 10 digits long and start with '04`,
  })
}
